import { render, staticRenderFns } from "./RuleTargetCpa.vue?vue&type=template&id=66c7e196"
import script from "./RuleTargetCpa.vue?vue&type=script&lang=js"
export * from "./RuleTargetCpa.vue?vue&type=script&lang=js"
import style0 from "./RuleTargetCpa.vue?vue&type=style&index=0&id=66c7e196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports